export default __webpack_public_path__ + "static/media/all_star-limited.9ca81bec.png";